import { Component } from '@angular/core';

@Component({
    selector: 'app-pstx-terms-conditions',
    templateUrl: './pstx-terms-conditions.component.html',
    standalone: false
})
export class PstxTermsConditionsComponent {}
